import Checkbox, { ICheckboxChange, IProps as ICheckboxProps } from "@components/inputs/checkbox";
import { Label, MonthCheckboxSelectorWrapper } from "@pages/payroll/Eldp/MonthCSSZSelector.styles";
import React, { useCallback, useMemo } from "react";
import TestIds from "../../../testIds";

interface IProps {
    onChange: (value: string) => void;
    value?: string;
    hideMasterCheckbox?: boolean;
    name?: string;
}


const MonthCheckboxSelector: React.FC<IProps> = (props) => {
    const { onChange, value, hideMasterCheckbox, name } = props;

    const labels = useMemo(() => {
        const labels: string[] = [];
        for (let i = 1; i <= 12; i++) {
            labels.push(i.toString());
        }
        !hideMasterCheckbox && labels.push("1-12");
        return labels;
    }, [hideMasterCheckbox]);

    const handleChange = useCallback((id: string, checked: boolean) => {
        const newValue = value ? value.split("") : Array(hideMasterCheckbox ? 12 : 13).fill("0");
        const index = labels.indexOf(id);
        if (index !== -1) {
            newValue[index] = checked ? "1" : "0";
        }
        onChange(newValue.join(""));
    }, [onChange, value, labels]);

    const areMonthsDisabled = value && value[12] === "1";
    const isMasterDisabled = value && value.slice(0, 12).split("").some(v => v === "1");

    return (
        <MonthCheckboxSelectorWrapper
            $hideMasterCheckbox={!!hideMasterCheckbox}
            data-testid={TestIds.MonthCheckboxSelector}
            data-name={name}>
                {labels.map(item => (<Label key={item} data-testid={TestIds.CheckboxLabel}>{item}</Label>))}
                {labels.map((item, idx) => (
                        <CheckboxWrapped id={item}
                                         key={`checkbox-${item}`}
                                         onChange={handleChange}
                                         isDisabled={idx < 12 ? areMonthsDisabled : isMasterDisabled}
                                         checked={value?.[idx] === "1"} />
                ))}
        </MonthCheckboxSelectorWrapper>
    );
};

interface IWrappedCheckboxProps extends Omit<ICheckboxProps, "onChange"> {
    id: string;
    onChange: (id: string, value: boolean) => void;
}

const CheckboxWrapped: React.FC<IWrappedCheckboxProps> = (({ onChange, id, ...restProps }) => {
    const handleChange = useCallback((args: ICheckboxChange) => {
        onChange(id, args.value);
    }, [onChange, id]);

    return (
            <Checkbox onChange={handleChange} {...restProps} />
    );
});

export default MonthCheckboxSelector;